import { Buffer } from 'buffer';

export class AppUtil {
	//判断是否是有效的手机号
	static isPhoneNumber(phoneNumber: string) {
		let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
		if (!myreg.test(phoneNumber)) {
			return false;
		} else {
			return true;
		}
	}
	/**
	 * 是否为空
	 * @param value 值
	 */
	static isEmpty(value: any): boolean {
		if (value == null || value == 'null' || (typeof value === 'string' && value.replace(/\s*/g, '').length == 0)) {
			return true;
		} else if (this.isObject(value)) {
			if (this.isArray(value) && this.length == 0) {
				return true;
			} else if (this.isJsonString(value) && JSON.stringify(value) == '{}') {
				return true;
			}
		}
		return false;
	}

	/**
	 * 是否数组
	 * @param vaue 值
	 */
	static isArray(value: any): boolean {
		return Array.isArray(value);
	}

	/**
	 * 是否对象
	 * @param vaue 值
	 */
	static isObject(value: any): boolean {
		return typeof value === 'object' && !this.isArray(value);
	}

	static isJsonString(value: any) {
		try {
			if (JSON.stringify(value) == '{}') {
				return true;
			}
			JSON.parse(value);
		} catch (e) {
			return false;
		}
		return true;
	}

	/**
	 * 是否不为空
	 * @param value 值
	 */
	static isNotEmpty(value: any): boolean {
		return !this.isEmpty(value);
	}

	static getRandomNumStr(num: number): string {
		let result = '';
		for (let index = 0; index < num; index++) {
			result += Math.floor(Math.random() * 10);
		}
		return result;
	}

	static encodeBase64(str: string) {
		try {
			return Buffer.from(str, 'utf-8').toString('base64');
		} catch (ex) {
			return null;
		}
	}

	static isBase64Str(str: string): boolean {
		const exg = new RegExp('^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{4}|[A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)$');
		if (exg.test(str)) {
			return true;
		} else {
			return false;
		}
	}

	static decodeBase64(str: string) {
		try {
			if (this.isBase64Str(str)) {
				return Buffer.from(str, 'base64').toString();
			}
			return str;
		} catch (ex) {
			console.warn('base64解码失败：' + str);
			return null;
		}
	}

	static getFirstHost() {
		let host = this.getHost();
		if (host && host != null) {
			return host.split('.')[0];
		}
		return null;
	}

	static getHost() {
		let host = location.host;
		if (!host || host == null) {
			host = location.hostname;
		}
		return host;
	}
	// 获取当前网站的hostname
	static getHostName() {
		return window.location.hostname;
	}
}
